module.exports = __webpack_public_path__ + "static/media/HK-HKBU.b6f4a30d.png";